export const actionTypes = {
  ADD_EMPLOYEE_SUCCESS: "ADD_EMPLOYEE_SUCCESS",
  SET_EMPLOYEE_ID: "SET_EMPLOYEE_ID",
  SHOW_ERROR: "SHOW_ERROR",
  SET_EDUCAITON_LIST: "SET_EDUCAITON_LIST",
  SET_FAMILY_LIST: "SET_FAMILY_LIST",
  SET_SKILL_LIST: "SET_SKILL_LIST",
  SET_EMPLOYEE_DETAILS: "SET_EMPLOYEE_DETAILS",
  CLEAR_EMPLOYEE_DETAILS: "CLEAR_EMPLOYEE_DETAILS",
  SET_WORK_HISTORY_LIST: "SET_WORK_HISTORY_LIST",
  SHOW_EMPLOYEE_LIST: "SHOW_EMPLOYEE_LIST",
  ADD_BTN: "ADD_BTN",
  EDIT_BTN: "EDIT_BTN",
  CANCEL_BTN: "CANCEL_BTN",
  CANCEL_BTN_EMPLOYEE: "CANCEL_BTN_EMPLOYEE",
  ADD_BTN_EMPLOYEE: "ADD_EMPLOYEE_BTN",
  CLEAR_EMPLOYEE_FIELDS: "CLEAR_EMPLOYEE_FIELDS",
  SHOW_EMPLOYEE_DETAILS: "SHOW_EMPLOYEE_DETAILS",
  EMPLOYEE_SEARCH_TEXT: "EMPLOYEE_SEARCH_TEXT",
  CLEAR_EMP_DATA: "CLEAR_EMP_DATA",
  DELETE_EDUCATION_ARRAY: "DELETE_EDUCATION_ARRAY",
  DELETE_FAMILY_ARRAY: "DELETE_FAMILY_ARRAY",
  DELETE_WORK_ARRAY: "DELETE_WORK_ARRAY",
  DELETE_SKILL_ARRAY: "DELETE_SKILL_ARRAY",
  EDIT_EMPLOYEE_DETAILS: "EDIT_EMPLOYEE_DETAILS",
  CHECK_WORK_HISTORY_CHANGE: "CHECK_WORK_HISTORY_CHANGE",
  CHECK_SKILL_INFO_CHANGE: "CHECK_SKILL_INFO_CHANGE",
  CHECK_FAMILY_INFO_CHANGE: "CHECK_FAMILY_INFO_CHANGE",
  CHECK_EDUCATION_INFO_CHANGE: "CHECK_EDUCATION_INFO_CHANGE",
  CHECK_CONTACT_INFO_CHANGE: "CHECK_CONTACT_INFO_CHANGE",
  CHECK_PERSONAL_INFO_CHANGE: "CHECK_PERSONAL_INFO_CHANGE",
  CHECK_EMP_DETAIL_CHANGE: "CHECK_EMP_DETAIL_CHANGE",
  CLEAR_CHANGE_WIZARD: "CLEAR_CHANGE_WIZARD",
  LOADING_SHOW: "LOADING_SHOW",
  LOADING_HIDE: "LOADING_HIDE",
  IS_VALID_FORM: "IS_VALID_FORM",
  SET_PERSONAL_INFO_ERRORS: "SET_PERSONAL_INFO_ERRORS",
  SET_CONTACT_INFO_ERRORS: "SET_CONTACT_INFO_ERRORS",
  SET_WORKHISTORY_INFO_ERRORS: "SET_WORKHISTORY_INFO_ERRORS",
  SET_EDUCATION_INFO_ERRORS: "SET_EDUCATION_INFO_ERRORS",
  SET_SKILL_INFO_ERRORS: "SET_SKILL_INFO_ERRORS",
  SET_FAMILY_INFO_ERRORS: "SET_FAMILY_INFO_ERRORS",
  SET_OTHER_INFO_ERRORS: "SET_OTHER_INFO_ERRORS",
  CLEAR_EDUCATION_ERROR: "CLEAR_EDUCATION_ERROR",
  CLEAR_FAMILY_ERROR: "CLEAR_FAMILY_ERROR",
  CLEAR_SKILL_ERROR: "CLEAR_SKILL_ERROR",
  CLEAR_WORK_HISTORY_ERROR: "CLEAR_WORK_HISTORY_ERROR",
  CLEAR_ERROR_OBJECT: "CLEAR_ERROR_OBJECT",
  SET_FILE_DETAIL: "SET_FILE_DETAIL",
  CLEAR_FILE_DETAIL: "CLEAR_FILE_DETAIL",
  PROFILE_IMAGE_SAVE_BTN: "PROFILE_IMAGE_SAVE_BTN",
  DOWNLOAD_TEMPLATE: "DOWNLOAD_TEMPLATE",
  BULK_UPLOAD: "BULK_UPLOAD",
  SHOW_BULK_ERROR: "SHOW_BULK_ERROR",
  SHOW_BULK_SUCCESS: "SHOW_BULK_SUCCESS",
  SET_EMP_DETAIL: "SET_EMP_DETAIL",
  SET_EMP_DETAIL_ERRORS:"SET_EMP_DETAIL_ERRORS"
};
